/*
* @Description: 订单催付创建
 * @Author: your name
 * @LastEditors: yang chenglin
 */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Balloon, Button, Checkbox, DatePicker, Dialog, Icon, Input, Radio, Select, Switch,NumberPicker } from '@alifd/next';
import { Servlets } from '@/service';
import { history } from 'ice';
import LzMsg from '@/components/common/LzMsg';
import AreaChoose from './components/AreaChoose';
import SelectGoods from '@/components/SelectGoods';
import utils from '@/common/utils';
import SectionTitle from './components/SectionTitle';
import Dialog_GenerateShortURL from '@/pages/OrderSelection/components/Dialog_GenerateShortURL';
import SmsTemplate from '@/components/SMS/OrderSmsTemplate';
import styles from './index.module.scss';
import CONSTANTS from '@/utils/constant';

const ADDLENGTH = CONSTANTS.LZ_SMS_CANCEL_WORD.length + 3;

// 参数：优先级下拉列表
const taskPrioritySelect = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
];
// 催付条件， 下拉数据源
const payHourSelect = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
const orderHourSelect = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
const payMinuteSelect = [5, 10, 15, 20, 25, 30];

const OrderPaymentCreate = (props) => {
  // 时间选择器
  const { RangePicker } = DatePicker;
  const { Tooltip } = Balloon;
  // 上次修改时间
  const [updateTime, setUpdateTime] = useState();
  // 自动催付开启状态
  const [isOpen, setOpen] = useState(true);
  // 优先级
  const [taskPriority, setTaskPriority] = useState(1);
  // 查看页面disabled
  const [pageDisable, setPageDisable] = useState(false);
  // 任务设置的值
  const [taskForm, setTaskForm] = useState({
    taskName: '', // 任务名称
    timeRadioStatu: 0, // 任务时间，0不限制，1自定义时间
    startTime: '', // 开始时间
    endTime: '', // 结束时间
    payHour: 0, // 下单小时
    payMinute: 30, // 下单分钟
    payMoneyStatu: false, // 付款金额是否勾选
    payMoney1: 0, // 第一个付款金额
    payMoney2: 0, // 第二个付款金额
    commodityNumStatu: false, // 商品数量是否勾选
    commodityNum1: 0, // 第一个商品数量
    commodityNum2: 0, // 第二个商品数量
    sendTimeStatu: 1, // 发送时段，1是不限制，2是指定时间段
    filterCondition: true, // 过滤条件一天只发一次
    limitCondition: false, // 限制条件
    limitCount: 0, // 限制条件的短信发送条数
    skuType: 1, // 催付商品：全部商品1(ids为空)，指定为2，排除是3
  });
  // 发送时间段
  const [ranges, setRanges] = useState([{
    start:0,
    end:0
  }]);
  // 修改发送时段函数
  const changeRange = (index, start, end) => {
    ranges[index] = {
      start,
      end,
    };
    setRanges([...ranges]);
  };
  // 添加发送时间段函数
  const addRange = () => {
    // 之前的数据加入新的数据
    setRanges([...ranges, {
      start: 0,
      end: 0,
    }]);
  };
  // 删除发送时段
  const deleteRange = (index) => {
    ranges.splice(index, 1);
    setRanges([...ranges]);
  };
  // 发送量和限定剩余
  const [sendCount, setSendCount] = useState({
    consume: 0,
    surplus: 0,
  });
  // 当前taskId的发送量和限定剩余
  const getSendAndRemain = (id) => {
    const obj = id ? { taskId: id } : {};
    Servlets('getSendAndRemain', obj).then((res: any) => {
      setSendCount(res.data);
    });
  };
  // 添加商品弹窗
  const [goodsDialog, setGoodsDialog] = useState(false);
  // 选中的skuid
  const [skuIds, setSkuIds] = useState([]);
  // 选中的商品
  const [selectGoods, setSelectGoods] = useState([]);
  // 催付地区
  const [area, setArea] = useState({
    type: 1,
    ids: [],
  });
  // 催付地区子组件传值给父组件
  const ChooseArea = (value) => {
    let tempList = [];
    value.forEach((item) => {
      tempList.push(item.toString());
    });
    setArea({
      ...area,
      ids: tempList,
    });
  };
  const chooseAreaType = (value) => {
    setArea({
      ids:[],
      type: value,
    });
  };
  // 短信签名
  const [messageSign, setMessageSign] = useState('');
  // 获取短信签名

  const getSmssign = () => {
    Servlets('getTitle', {}).then((res: { data: string }) => {
      const { shopName } = res.data;
      Servlets('getSmssign', { shopName }).then((res: any) => {
        if (res.success) {
          setMessageSign(res.data);
        }
      });
    });
  };
  const [messageForm, setMessageForm] = useState({
    messageContent: '', // 短信内容
    messageCount: 1, // 短信条数
  });
  // 一次发送右侧手机展示内容
  const [phoneMsg, setPhoneMsg] = useState('');
  // 二次发送右侧手机展示内容
  const [phoneMsgSecond, setPhoneMsgSecond] = useState('');
  // 账户余量
  const [accountRemain, setAccountRemain] = useState();
  // 获取短信余额
  const getSmsNum = () => {
    Servlets('getTitle', {}).then((res) => {
      if (res.success) {
        LzMsg.success('刷新成功');
      }
      setAccountRemain(res.data.smsTotal);
    });
  };
  // 一次发送测试短信手机号
  const [receivePhone, setReceivePhone] = useState('');
  const [openShortUrlDialog, setOpenShortUrlDialog] = useState(false);// 是否打开生成短链接弹窗
  const [smsTemplateDialog, setSmsTemplateDialog] = useState(false);// 是否打开选择模板弹窗
  const [secondSmsTemplateDialog, setSecondSmsTemplateDialog] = useState(false);// 是否打开二次催付选择模板弹窗
  // 二次催付部分
  const [secondPayment, setSecondPayment] = useState(false);
  // 二次催付延迟时间
  const [delayTime, setDelayTime] = useState({
    hours: 0,
    minutes: 5,
  });
  // 二次催付短信内容
  const [messageFormSecond, setMessageFormSecond] = useState({
    messageContent: '', // 短信内容
    messageCount: 1, // 短信条数
  });
  // 二次催付开启状态
  const [secondTaskActive, setSecondTaskActive] = useState(false);
  // 二次发送测试短信手机号
  const [receivePhoneSecond, setReceivePhoneSecond] = useState('');
  // 选中的短信信息
  const [selectedSms, setSelectedSms] = useState({});
  // 选中的二次短信信息
  const [selectedSmsSecond, setSelectedSmsSecond] = useState({});
  // 发送测试短信
  const sendTestSms = (v, mobile) => {
    const params = {
      channelType: 1, // 短信类型 0-营销短信，1-关怀短信
      mobile,
      smsAccount: v.smsAccount,
      sign: messageSign,
      templateId: v.templateId,
      templateParam: v.templateId,
      replace: 1,
      fullContent: v.templateContent,
    };
    // console.log('🚀params===', params);
    Servlets('sendTestsms', params).then((res) => {
      LzMsg.success('发送成功');
    }).catch((err) => {
      console.log('🚀err===', err);
    });
  };
  // 活动截止日期
  const [activityEndDate, setActivityEndDate] = useState(0);
  //  获取剩余天数
  const getShopTitle = () => {
    Servlets('getTitle', {}).then((res: any) => {
      setActivityEndDate(res.data.remainingDay);
      setAccountRemain(res.data.smsTotal);
    });
  };
  // 禁止选择时间
  const disabledDate = function (date, view) {
    // 返回当前日期之前日期和活动结束日期 （结束日期需要接口）
    return date.valueOf() < moment().subtract(1, 'day').valueOf() || date.valueOf() > moment().add(Number(activityEndDate), 'days').valueOf();
  };
  // 选择时间
  const selectTime = (value) => {
    let startT = '';
    let endT = '';
    startT = value[0] ? moment(value[0]).format('YYYY-MM-DD') : '';
    endT = value[1] ? moment(value[1]).format('YYYY-MM-DD') : '';
    setTaskForm({ ...taskForm, startTime: startT, endTime: endT });
  };
  // 时间段重合校验排序规则
  const sortRule = (a,b) =>{
    if(a.start === b.start){
      return a.end-b.end
    }
    else{
      return a.start-b.start
    }
  }
  // 保存接口
  const saveCallforpayment = (list?) => {
    const tempList = []; // 保存发送时间段的数据
    let uniqueTempList = []; // 保存去重后的时间段的数据
    if (ranges && taskForm.sendTimeStatu === 2) {
      for (let i = 0; i < ranges.length; i++) {
        if ((+ranges[i].start >= 0) && (+ranges[i].end >= 0)) {
          const temp = `${ranges[i].start}-${ranges[i].end}`;
          tempList.push(temp);
        } else {
          LzMsg.error('请确认发送时段是否完整填写');
          return false;
        }
      }
    }
    if (tempList.length > 0) {
      uniqueTempList = [...new Set(tempList)];
    }
    const selectGoodsIds = selectGoods.map((item) => item.skuId);
    const newSkuIds = skuIds.filter((i) => selectGoodsIds.includes(i));
    // 校验
    if(taskForm.sendTimeStatu === 2 ) {
      let newRanges = [...ranges].sort(sortRule);
      for(let i = 1;i<newRanges.length;i++)
      {
        if(+newRanges[i].start<+newRanges[i-1].end){
          return (
            LzMsg.error('请选择正确的发送时段,多个时间段不可交叉')
          )
        } else {
          continue
        }
      }
  }
    if (taskForm.sendTimeStatu === 2 && (tempList.length !== uniqueTempList.length)) {
      LzMsg.error('提交失败，发送时段重复');
      return false;
    } else if (!taskForm.taskName) {
      LzMsg.error('提交失败，任务名称不能为空');
      return false;
    } else if (taskForm.timeRadioStatu === 1 && (!taskForm.startTime || !taskForm.endTime)) {
      LzMsg.error('请确认任务时间是否填写完整');
      return false;
    }  else if (
      (taskForm.payMoneyStatu && taskForm.payMoney1 && taskForm.payMoney2 && (+taskForm.payMoney1 >= +taskForm.payMoney2))
      ||(taskForm.payMoneyStatu && taskForm.payMoney1 && taskForm.payMoney2===0 && (+taskForm.payMoney1 >= +taskForm.payMoney2))
    ) {
      LzMsg.error('错误的付款金额范围');
      return false;
    } else if (
      taskForm.payMoneyStatu === true &&
      Number(taskForm.payMoney1) === 0 &&
      Number(taskForm.payMoney2) === 0
    ) {
      LzMsg.error('错误的付款金额范围');
      return false;
    } else if (
      taskForm.commodityNumStatu === true &&
      Number(taskForm.commodityNum1) === 0 &&
      Number(taskForm.commodityNum2) === 0
    ) {
      LzMsg.error('错误的商品数量范围');
      return false;
    }
    else if (
      (taskForm.commodityNumStatu && taskForm.commodityNum1 && taskForm.commodityNum2 && (+taskForm.commodityNum1 >= +taskForm.commodityNum2))
    ||(taskForm.commodityNumStatu && taskForm.commodityNum1 && taskForm.commodityNum2===0 && (+taskForm.commodityNum1 >= +taskForm.commodityNum2))
    ) {
      LzMsg.error('错误的商品数量范围');
      return false;
    } else if (taskForm.limitCondition && (+taskForm.limitCount <= 0)) {
      LzMsg.error('限制条件中短信发送量不能为空或0');
      return false;
    } else if (taskForm.skuType === 2 && skuIds.length === 0) {
      LzMsg.error('请选择指定的催付商品');
      return false;
    } else if (taskForm.skuType === 3 && skuIds.length === 0) {
      LzMsg.error('请选择排除商品');
      return false;
    } else if (+area.type === 2 && area.ids.length === 0) {
      LzMsg.error('请选择指定的催付地区');
      return false;
    } else if (+area.type === 3 && area.ids.length === 0) {
      LzMsg.error('请选择排除地区');
      return false;
    } else if (!messageForm.messageContent) { // 校验 短信内容未选择
      LzMsg.error('短信内容不能为空');
      return false;
    } else if ((+messageSign.length) + (+messageForm.messageContent.length) + ADDLENGTH > 329) {
      LzMsg.error('短信内容过长，请重新编辑文案');
      return false;
    } else if (secondTaskActive && !messageFormSecond.messageContent) { // 校验 短信内容未选择
      LzMsg.error('二次催付短信内容不能为空');
      return false;
    } else if (messageSign && messageFormSecond.messageContent && (+messageSign.length) + (+messageFormSecond.messageContent.length) + ADDLENGTH > 329) {
      LzMsg.error('二次催付短信内容过长，请重新编辑文案');
      return false;
    }

    const params = {
      taskPriority,
      taskActive: isOpen, // 状态是否开启
      taskName: taskForm.taskName,
      startTime: taskForm.timeRadioStatu ? moment(`${taskForm.startTime} 00:00:00`).valueOf() : moment().format('x'),
      endTime: taskForm.timeRadioStatu ? moment(`${taskForm.endTime} 23:59:59`).valueOf() : moment().add(100, 'years').format('x'),
      orderCondition: { // 催付条件
        amount: `${taskForm.payMoney1?+taskForm.payMoney1:0}-${taskForm.payMoney2===undefined?10000000:+taskForm.payMoney2}`,
        skuNum: `${taskForm.commodityNum1?+taskForm.commodityNum1:0}-${taskForm.commodityNum2===undefined?100000:+taskForm.commodityNum2}`,
        skus: {
          type: taskForm.skuType,
          ids: taskForm.skuType !== 1 ? skuIds : [],
        },
        area,
      },
      sendingCondition: { // 发送时段
        delay: moment.duration({ minutes: taskForm.payMinute, hours: taskForm.payHour }).asMilliseconds(),
        durations: {
          type: taskForm.sendTimeStatu, // 不限制时间段：1(spans为空),指定时间段：2
          spans: taskForm.sendTimeStatu === 2 ? tempList : [],
        },
        oncePerDay: taskForm.filterCondition, // 过滤条件一天只发一次
        quantityLimit: taskForm.limitCount, // 限制条件 多少条
      },
      smsContent: { // 列表短信
        sign: messageSign,
        content: `【${messageSign}】${messageForm.messageContent} ${CONSTANTS.LZ_SMS_CANCEL_WORD}`,
        templateId: selectedSms.templateId,
        smsAccount: selectedSms.smsAccount,
      },
      secondary: { // 二次催付
        taskActive: secondTaskActive, // 二次催付是否开启
        sendingCondition: {
          delay: moment.duration({ minutes: delayTime.minutes, hours: delayTime.hours }).asMilliseconds(),
        },
        smsContent: {
          sign: messageSign,
          content: secondTaskActive ? `【${messageSign}】${messageFormSecond.messageContent} ${CONSTANTS.LZ_SMS_CANCEL_WORD}` : '',
          templateId: secondTaskActive ? selectedSmsSecond.templateId : '',
          smsAccount: secondTaskActive ? selectedSmsSecond.smsAccount : '',
        },
      },
    };
    // console.log('🚀params===', params)
    // return
    if (pageStatus === 1) {
      Servlets('getSameName', {}).then((res) => {
        const duplicateName = res.data.find((v) => v === taskForm.taskName);
        if (duplicateName) {
          LzMsg.error('任务名已存在');
        } else {
          Servlets('saveCallforpayment', params).then((res) => {
            LzMsg.success('提交成功');
            history.push('/ordersCare', { from: 'payment' });
          });
        }
      });
    } else if (pageStatus === 3) {
      params.taskId = initInfo.id;
      Servlets('updatePaymentList', params).then((res) => {
        LzMsg.success('更新成功');
        history.push('/ordersCare', { from: 'payment' });
      });
    }
  };
  /** 设置 Header 面包屑 */
  const setBreadcrumb = () => {
    /** 设置Header面包屑 */
    utils.setBreadcrumb({
      name: '订单关怀', // 一级页面名称
      url: '/web/ordersCare', // 一级页面url
      children: {
        name: '订单催付', // 二级页面名称
        url: '/web/ordersCare', // 二级页面url
        children: {
          name: '订单催付任务设置', // 三级页面名称
          url: '', // 三级页面url
        },
      },
    });
  };
  function TimeToMsel(param) {
    const tempTime = moment.duration(param);
    const y = `${tempTime.hours() }时${ tempTime.minutes()}`;
    return y;
  }

  // 截取短信中需要的内容
  const cutSmsContent = (v) => {
    // console.log(v, "v")
    // 如果不存在
    const arr = v.split('】');
    // console.log(arr)
    if (arr[1]) {
      const newArr = arr[1].split(` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`);
      return newArr[0];
    }
  };
  // 判断短信条数
  const countSms = (v) => {
    let tempCount;
    if (v.length <= 70) {
      tempCount = Math.ceil(v.length / 70);
    } else {
      tempCount = Math.ceil(v.length / 67);
    }
    return tempCount;
  };
  // 1是新建，2是查看，3是修改
  let { pageStatus } = props.location.state;
  // 父组件传过来的值
  let initInfo = props.location.state.info;
  // console.log(initInfo, "initInfo")
  const setInitData = () => {
    if (pageStatus !== 1) {
      if (pageStatus === 2) {
        setPageDisable(true); // 禁用
      }
      const delay = TimeToMsel(initInfo.sendingCondition.delay); // 将发送时段毫秒值转为几时几分
      const time1 = moment(initInfo.startTime).format('YYYY-MM-DD');
      const time2 = moment(initInfo.endTime).format('YYYY-MM-DD');
      setOpen(initInfo.taskActive); // 任务开关状态
      setTaskPriority(initInfo.taskPriority); // 优先级
      // 任务设置
      setTaskForm({
        ...taskForm,
        taskName: initInfo.taskName,
        timeRadioStatu: initInfo.time === '无限制' ? 0 : 1,
        startTime: initInfo.time === '无限制' ? '' : time1,
        endTime: initInfo.time === '无限制' ? '' : time2,
        payHour: +delay.split('时')[0],
        payMinute: +delay.split('时')[1],
        payMoneyStatu: initInfo.orderCondition.amount !== '0-0',
        payMoney1: +initInfo.orderCondition.amount.split('-')[0],
        payMoney2: +initInfo.orderCondition.amount.split('-')[1],
        commodityNumStatu: initInfo.orderCondition.skuNum !== '0-0',
        commodityNum1: +initInfo.orderCondition.skuNum.split('-')[0],
        commodityNum2: +initInfo.orderCondition.skuNum.split('-')[1],
        sendTimeStatu: initInfo.sendingCondition.durations.type,
        filterCondition: initInfo.sendingCondition.oncePerDay,
        limitCondition: !!((initInfo.sendingCondition.quantityLimit && Number(initInfo.sendingCondition.quantityLimit) !== 0)),
        limitCount: initInfo.sendingCondition.quantityLimit,
        skuType: initInfo.orderCondition.skus.type,
      });
      if (initInfo.sendingCondition.durations.type === 2) {
        initInfo.sendingCondition.durations.spans.map((item, index) => {
          addRange();
          changeRange(index, item.split('-')[0], item.split('-')[1]);
        });
      }
      getSendAndRemain(initInfo.id); // 当前taskId的发送量和限定剩余
      setSkuIds(initInfo.orderCondition.skus.ids); // 催付商品

      // setSelectGoods(arr);
      setArea(initInfo.orderCondition.area); // 催付地区
      // 短信设置
      setMessageSign(initInfo.smsContent.sign);
      setMessageForm({
        messageContent: cutSmsContent(initInfo.smsContent.content),
        messageCount: countSms(initInfo.smsContent.content),
      });
      setSelectedSms({ templateId: initInfo.smsContent.templateId, smsAccount: initInfo.smsContent.smsAccount });

      // 二次催付设置
      const delaySecond = TimeToMsel(initInfo.secondary.sendingCondition.delay); // 将发送时段毫秒值转为几时几分
      setDelayTime({ ...delayTime, hours: +delaySecond.split('时')[0], minutes: +delaySecond.split('时')[1] });
      setSecondTaskActive(initInfo.secondary.taskActive);
      setMessageFormSecond({
        ...messageFormSecond,
        messageContent: cutSmsContent(initInfo.secondary.smsContent.content),
        messageCount: countSms(initInfo.secondary.smsContent.content),
      });
      initInfo.secondary.taskActive && setSelectedSmsSecond({
        templateId: initInfo.smsContent.templateId,
        smsAccount: initInfo.smsContent.smsAccount,
      });
    } else {
      getSendAndRemain(); // 当前taskId的发送量和限定剩余
      getSmssign(); // 获取短信签名
    }
  };
  useEffect(() => {
    setBreadcrumb();// 设置Header面包屑
    // getSmssign(); // 获取短信签名
    getShopTitle(); // 获取剩余天数
    // getSendAndRemain(); //当前taskId的发送量和限定剩余
    setInitData();
  }, [skuIds]);
  // 一次发送右侧手机模式预览：(折行和空格同时跟随输入展示)
  useEffect(() => {
    const signs = messageSign ? `【${messageSign}】` : '【】';
    let cont = messageForm.messageContent ? messageForm.messageContent : '';
    cont = cont?.replace(/\n/g, '<br/>');
    cont = cont?.replace(/\s/g, '&nbsp;');
    setPhoneMsg(`${signs + cont } ${CONSTANTS.LZ_SMS_CANCEL_WORD}`);
  }, [messageForm.messageContent, messageSign]);
  // 二次发送右侧手机模式预览：(折行和空格同时跟随输入展示)
  useEffect(() => {
    const signs = messageSign ? `【${messageSign}】` : '【】';
    let cont = messageFormSecond.messageContent ? messageFormSecond.messageContent : '';
    cont = cont?.replace(/\n/g, '<br/>');
    cont = cont?.replace(/\s/g, '&nbsp;');
    setPhoneMsgSecond(`${signs + cont } ${CONSTANTS.LZ_SMS_CANCEL_WORD}`);
  }, [messageFormSecond.messageContent, messageSign]);
  useEffect(()=>{
    if(pageStatus !== 1){
      setUpdateTime(initInfo.updateTime)
    }
  },[])
  return (
    <div className={styles.main}>
      {/* <div className={styles.firstTitle}>
        订单催付任务设置
      </div> */}
      <div className={styles.notice}>
        <div className={styles.font}>
          {/* <div style={{ width: '16px', height: '100%', textAlign: 'right' }}>
            <span className="iconfont icon-icon4-37" style={{ color: "#2d8cf0" }}></span>
          </div> */}
          <Icon type="prompt" size="small" style={{ color: '#f0b447' }} />
          <div style={{ width: '98%', height: '100%', marginLeft: '8px' }}>
            1. 自动通知买家对订单进行支付，有效提高订单付款率。如更改设置，新设置只对保存设置后下单的订单生效。<br />
            2. 同一订单满足多条已开启任务时，只按照优先级最高的任务执行。可单击调整优先级，数字越小优先级越高。<br />
            3. 同一订单满足多条优先级相同任务时，只按照发送时间最早的任务执行。
          </div>
        </div>
        <div className={styles.openclose} style={{ background: '#FFFFFF' }}>
          {/* <div className={styles.opencloseTop}>
            <div className={styles.opchild}></div>
            <div className={styles.opchild} style={{ lineHeight: '60px' }}>优先级</div>
            <div className={styles.opchild}></div>
          </div> */}
          <div className={styles.opencloseBottom}>
            <div className={styles.opchild} style={{ display: 'flex', alignItems: 'center' }}>
              <div className={styles.openicon}>
                { // 催付是否开启图标
                  isOpen === true ? (
                    <span
                      className={'iconfont icon-icon4-23'}
                      style={{ color: '#00BB66', fontSize: '48px' }}
                    />
                  ) : (<span
                    className={'iconfont icon-icon4-39'}
                    style={{ color: '#9CA7B6', fontSize: '48px' }}
                  />)
                }
              </div>
              {/* 订单催付是否开启 */}
              {isOpen === true
                ?
                (<div className={styles.opentext}>
                  <span style={{
                    color: '#333333',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    lineHeight: pageStatus === 1 ? '' : '34px',
                  }}
                  >已开启<br />
                  </span>
                  {pageStatus !== 1 && <span style={{
                    lineHeight: '26px',
                    color: '#657180',
                  }}
                  > 上次修改时间：{updateTime ? moment(updateTime).format('YYYY-MM-DD HH:mm:ss') : '--------'}
                  </span>}
                </div>)
                : (<div className={styles.opentext}>
                  <span style={{
                    color: '#333333',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    lineHeight: pageStatus === 1 ? '' : '34px',
                  }}
                  >已关闭<br />
                  </span>
                  {pageStatus !== 1 && <span style={{
                    lineHeight: '26px',
                    color: '#657180',
                  }}
                  > 上次修改时间：{updateTime ? moment(updateTime).format('YYYY-MM-DD HH:mm:ss') : '--------'}
                  </span>}
                </div>)
              }
            </div>
            <div className={styles.opchild} style={{ display: 'flex', alignItems: 'center' }}>
              {/*  优先级下拉 */}
              <span>优先级：</span>
              <Select
                followTrigger
                defaultValue={1}
                // defaultVisible = {true}  //下拉列表是否展开
                dataSource={taskPrioritySelect}
                value={taskPriority}
                disabled={pageDisable}
                style={{ width: '200px' }}
                onChange={(value) => {
                  setTaskPriority(value);
                }}
              />
            </div>
            <div className={styles.opchild}>
              <div
                style={{ textAlign: 'right', float: 'left', clear: 'both' }}
                className="switch-reset-color-orderPaymentMIssion"
              >
                <Switch
                  onChange={(checked) => setOpen(checked)}
                  checked={isOpen}
                  disabled={pageDisable}
                  style={{ marginBottom: '0px', marginRight: '8px' }}
                />
              </div>
              <div style={{ float: 'left', paddingLeft: '3px', paddingRight: '40px' }}>
                { // 状态
                  isOpen === true ? (<span style={{ lineHeight: '26px' }}>已开启</span>) : (
                    <span style={{ lineHeight: '26px' }}>已关闭</span>)
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.taskSetting}>
        <SectionTitle attr-intro="段落标题" title="任务设置" preface="1" />
        <div style={{ padding: '0 124px 40px 124px' }}>
          {/* <div className={styles.title}>任务设置</div> */}
          <div className={`${styles.dutyName} ${styles.displayFlex}`}>
            <div className={styles.marginRight}>
              <span style={{ color: 'red' }}>*</span>任务名称：
            </div>
            <div className={styles.dutyNameInput}>
              <Input
                name="dutyName"
                placeholder="请输入任务名称"
                onChange={(value) => {
                  setTaskForm({ ...taskForm, taskName: value });
                }}
                value={taskForm.taskName}
                showLimitHint
                disabled={pageDisable}
                maxLength={32}
                trim
                style={{ width: 600 }}
              />
            </div>
          </div>
          <div className={`${styles.dutyTimeStatu} ${styles.displayFlex}`}>
            <div className={styles.marginRight}>
              <span style={{ color: 'red' }}>*</span>任务时间：
            </div>
            <div>
              <Radio.Group
                direction={'hoz'}
                value={taskForm.timeRadioStatu}
                disabled={pageDisable}
                onChange={(value) => {
                  if(+value === 0){
                    setTaskForm({ ...taskForm, timeRadioStatu: +value })
                  } else {
                    setTaskForm({ ...taskForm, timeRadioStatu: +value ,endTime:'',startTime:''})
                  }
                }}
              >
                <Radio value={0}>不限制<span style={{ color: 'red' }}>（需手动开启和关闭活动）</span></Radio>
                <Radio value={1}>自定义时间</Radio>
              </Radio.Group>
            </div>
          </div>
          {
            // 自定义时间
            taskForm.timeRadioStatu === 1 && <div className={styles.dutyTime}>
              <div className={styles.dutyTimeRange}>
                <RangePicker
                  style={{ width: '570px' }}
                  popupAlign="tr tr"
                  value={[taskForm.startTime, taskForm.endTime]}
                  onChange={selectTime}
                  disabledDate={disabledDate}
                  disabled={pageDisable}
                  followTrigger
                />
              </div>
              <div className={styles.dutyTimetext}>
                已开启的任务会在设定的开始时间开始执行催付任务，在到达结束时间自动关闭催付任务。
              </div>
            </div>
          }
          <div className={styles.Paymentconditions}>
            <div className={styles.PaymentChild}>
              {/* <div className={styles.PaymentChildLabel}>

              </div> */}
              <div className={styles.PaymentChildMain}>
                <div className={styles.Mainlabel}>
                  <span style={{ color: 'red' }}>*</span>
                  <span style={{ marginRight: 12 }}>催付条件：</span>
                  <span>当买家下单</span>
                </div>
                <div style={{ marginLeft: '76px' }}>
                  <div className={styles.MainInput}>
                    {/* <Select
                      followTrigger={true}
                      // defaultValue={0}
                      // defaultVisible = {true}  //下拉列表是否展开
                      dataSource={orderHourSelect}
                      value={taskForm.payHour}
                      onChange={(value) => setTaskForm({ ...taskForm, payHour: value })}
                      style={{ width: '278px' }}
                      disabled={pageDisable}
                      name="range" />
                    <span className={styles.spl}>小时</span> */}
                    <Select
                      aria-label="name is"
                      followTrigger
                      // defaultVisible = {true}  //下拉列表是否展开
                      dataSource={payMinuteSelect}
                      onChange={(value) => setTaskForm({ ...taskForm, payMinute: value })}
                      disabled={pageDisable}
                      value={taskForm.payMinute}
                      style={{ width: '278px' }}
                      name="range"
                    />
                    <span style={{ marginLeft: '10px' }}>分钟后仍未付款，向买家发送通知短信。
                    </span>
                  </div>
                  <div className={styles.Mainlabel}>
                    <Checkbox
                      onChange={(value) => {
                        if (!value) {
                          setTaskForm({
                            ...taskForm,
                            payMoneyStatu: value,
                            payMoney1: 0,
                            payMoney2: 0,
                          });
                        } else {
                          setTaskForm({ ...taskForm, payMoneyStatu: value });
                        }
                      }}
                      checked={taskForm.payMoneyStatu}
                      disabled={pageDisable}
                    />
                    <span style={{ marginLeft: '10px' }}>付款金额为</span>
                  </div>
                  <div className={styles.MainInput}>
                    <NumberPicker
                      name="payMoney1"
                      value={taskForm.payMoney1}
                      onChange={(value) => {
                        setTaskForm({
                          ...taskForm,
                          payMoney1: value?value:0,
                        });
                      }}
                      min={0}
                      max={9999999}
                      hasTrigger={false}
                      disabled={pageStatus === 2 ? pageDisable : !taskForm.payMoneyStatu}
                      style={{ width: '278px' }}
                    />
                    <span className={styles.spl}>-</span>
                    <NumberPicker
                      name="payMoney2"
                      value={taskForm.payMoney2}
                      onChange={(value) => {
                        setTaskForm({
                          ...taskForm,
                          payMoney2: value,
                        });
                      }}
                      min={0}
                      max={10000000}
                      hasTrigger={false}
                      disabled={pageStatus === 2 ? pageDisable : !taskForm.payMoneyStatu}
                      style={{ width: '278px' }}
                    />
                    <span style={{ marginLeft: '10px' }}>元时，发送催付短信，不勾选为不限制
                      <Tooltip
                        align="t"
                        trigger={<span
                          style={{ fontSize: '14px', marginLeft: '8px', cursor: 'pointer' }}
                          className={'iconfont icon-icon4-33'}
                        />}
                      >
                        只填起始金额大于该金额的订单都提醒，只填终止金额小于该金额的订单都提醒(订单金额为实付价)
                      </Tooltip>
                    </span>
                  </div>
                  <div className={styles.Mainlabel}>
                    <Checkbox
                      onChange={(value) => {
                        if (!value) {
                          setTaskForm({
                            ...taskForm,
                            commodityNumStatu: value,
                            commodityNum1: 0,
                            commodityNum2: 0,
                          });
                        } else {
                          setTaskForm({ ...taskForm, commodityNumStatu: value });
                        }
                      }}
                      checked={taskForm.commodityNumStatu}
                      disabled={pageDisable}
                    />
                    <span style={{ marginLeft: '10px' }}>商品数量为</span>
                  </div>
                  <div className={styles.MainInput}>
                    <NumberPicker
                      name="commodityNum1"
                      value={taskForm.commodityNum1}
                      onChange={(value) => {
                        setTaskForm({
                          ...taskForm,
                          commodityNum1: value?value:0,
                        });
                      }}
                      disabled={pageStatus === 2 ? pageDisable : !taskForm.commodityNumStatu}
                      min={0}
                      max={99999}
                      style={{ width: '278px' }}
                      hasTrigger={false}
                    />
                    <span className={styles.spl}>-</span>
                    <NumberPicker
                      name="commodityNum2"
                      value={taskForm.commodityNum2}
                      onChange={(value) => {
                        setTaskForm({
                          ...taskForm,
                          commodityNum2: value,
                        });
                      }}
                      hasTrigger={false}
                      min={0}
                      max={100000}
                      disabled={pageStatus === 2 ? pageDisable : !taskForm.commodityNumStatu}
                      style={{ width: '278px' }}
                    />
                    <span style={{ marginLeft: '10px' }}>件时，发送催付短信，不勾选为不限制
                      <Tooltip
                        align="t"
                        trigger={<span
                          style={{ fontSize: '14px', marginLeft: '8px', cursor: 'pointer' }}
                          className={'iconfont icon-icon4-33'}
                        />}
                      >
                        只填起始商品数量大于该数量的订单都提醒，只填终止商品数量小于该数量的订单都提醒。
                      </Tooltip>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`${styles.sendTimeStatu} ${styles.displayFlex}`}>
            <div className={styles.marginRight}>
              <span style={{ color: 'red' }}>*</span>发送时段：
            </div>
            <div>
              <Radio.Group
                direction={'hoz'}
                value={taskForm.sendTimeStatu}
                disabled={pageDisable}
                onChange={(value) => setTaskForm({ ...taskForm, sendTimeStatu: +value })}
              >
                <Radio value={1}>不限时间段</Radio>
                <Radio value={2}>指定时间段</Radio>
              </Radio.Group>
            </div>
          </div>
          {/* 指定时间段的筛选条件 */}
          {
            taskForm.sendTimeStatu === 2 && <div style={{
              width: '604px',
              background: '#F5F7F9',
              marginTop: '10px',
              paddingBottom: '20px',
              marginLeft: '76px',
              padding: '14px',
            }}
            >
              <Button
                text
                style={{
                  border: '1px dashed #D7DDE4',
                  width: '100%',
                  height: '30px',
                  margin: 'auto',
                  borderRadius: '2px',
                  marginTop: '15px',
                  color: '#3399FF',
                }}
                onClick={() => {
                  if (ranges.length < 5) {
                    addRange();
                  } else {
                    LzMsg.error('指定时间段可添加最多5个时段进行发送设置');
                  }
                }}
                disabled={pageDisable}
              >+添加发送时段
              </Button>
              <div className={styles.sendTimeBtn}>
                {
                  ranges.map((item, index) => (
                    <div key={index}>
                      <div
                        key={index}
                        className={`${styles.sendTimeChild}`}
                        style={{
                          marginTop: '15px',
                          display: 'flex',
                          alignItems: 'center',
                          flexWrap: 'wrap',
                        }}
                      >
                        <span style={{ color: '#333333' }}>每天&nbsp;&nbsp;</span>
                        <Select
                          followTrigger
                          dataSource={payHourSelect}
                          value={item.start}
                          onChange={(value) => {
                            changeRange(index, value, item.end);
                          }}
                          style={{ width: '120px' }}
                          disabled={pageDisable}
                        />
                        <span className={styles.spl}>&nbsp;&nbsp;时，至&nbsp;&nbsp;</span>
                        <Select
                          followTrigger
                          dataSource={payHourSelect}
                          value={item.end}
                          onChange={(value) => {
                            if (value < item.start) {
                              LzMsg.error('请选择正确的发送时段');
                            } else {
                              changeRange(index, item.start, value);
                            }
                          }}
                          style={{ width: '120px' }}
                          disabled={pageDisable}
                        />
                        <span style={{ marginLeft: '10px' }}>时发送提醒短信</span>
                        {
                          ranges.length > 1 && <Tooltip
                            align="t"
                            trigger={
                              <span
                                className={`iconfont icon-icon-07 ${styles['del-icon']}`}
                                style={{ marginLeft: '20px',
                                pointerEvents:
                                pageStatus === 2 ? 'none' : 'auto', }}
                                onClick={() => {
                                  deleteRange(index);
                                }}
                              />
                            }
                          >
                            <div style={{ width: '60px', paddingLeft: 'auto' }}>删除此时段</div>
                          </Tooltip>
                        }
                      </div>
                    </div>
                  ))
                }
              </div>
              <div className={styles.sendTimeNotice} style={{ marginTop: '20px' }}>
                <span
                  style={{ color: '#9CA7B6' }}
                >（不在选择时间段的催付订单，会在下个发送时间节点进行订单状态校验，若还满足发送条件，则进行补发）
                </span>
              </div>

            </div>
          }
          <div className={`${styles.filterCondition} ${styles.displayFlex}`}>
            <div className={styles.marginRight} style={{ marginLeft: 5 }}>
              过滤条件：
            </div>
            <div className={styles.filterConditionCheck}>
              <Checkbox
                disabled={pageDisable}
                checked={taskForm.filterCondition}
                onChange={(value) => setTaskForm({ ...taskForm, filterCondition: value })}
              />
              &nbsp; &nbsp;一天只发一次（勾选后24小时内买家有多个完成订单只发一次，二次催付不在此限制条件内）
            </div>
          </div>
          <div className={`${styles.limitCondition} ${styles.displayFlex}`}>
            <div className={styles.marginRight} style={{ marginLeft: 5 }}>
              限制条件：
            </div>
            <div style={{ width: 'calc(100% - 80px)', lineHeight: '24px' }}>
              <Checkbox
                onChange={(value) => {
                  if (!value) {
                    setTaskForm({ ...taskForm, limitCondition: value, limitCount: 0 });
                  } else {
                    setTaskForm({ ...taskForm, limitCondition: value });
                  }
                }}
                checked={taskForm.limitCondition}
                disabled={pageDisable}
              />
              &nbsp; &nbsp; 当短信发送量到达&nbsp;&nbsp;
              <Input
                name="limitCount"
                onChange={(value) => {
                  // 正则限制输入正整数，以及不能以00之类的数开头
                  setTaskForm({
                    ...taskForm,
                    limitCount: value.replace(/[^0-9]/g, '').replace(/^0[0-9]/g, '0'),
                  });
                }}
                maxLength={8}
                value={taskForm.limitCount}
                disabled={pageStatus === 2 ? pageDisable : !taskForm.limitCondition}
                trim
                style={{ width: '120px' }}
              />&nbsp;&nbsp;条时，自动停止催付任务<span
                style={{ color: '#9CA7B6' }}
              >（勾选后为最高优先级判断条件）
              </span>
              当前任务已发送<span style={{ color: 'red' }}>{sendCount.consume}</span>条，再发送<span
                style={{ color: 'red' }}
              >{
              sendCount.surplus === null ? (+taskForm.limitCount) : sendCount.surplus}
                                                                                   </span>条后，停止催付任务<span
                style={{ color: '#9CA7B6' }}
              >（若开启二次催付，共用发送总量）
                              </span>
            </div>
          </div>
          <div className={`${styles.displayFlex}`} style={{ marginTop: '20px', alignItems: 'flex-start' }}>
            <div className={styles.marginRight} style={{ paddingTop: '1px' }}>
              <span>
                <span style={{ color: '#FF3333' }}>*</span>催付商品：
              </span>
            </div>
            <Radio.Group
              value={taskForm.skuType}
              disabled={pageDisable}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '10px',
                width: 600,
              }}
              onChange={(v) => setTaskForm({ ...taskForm, skuType: +v })}
            >
              <Radio id="1" value={1}>全部商品</Radio>
              <Radio id="2" value={2}>指定商品</Radio>
              <Radio id="3" value={3}>排除商品</Radio>
              {/* <div style={{flex:'1'}}></div> */}
            </Radio.Group>
          </div>
          {
            taskForm.skuType !== 1 && <div style={{
              background: '#F5F7F9',
              paddingLeft: '15px',
              paddingTop: '20px',
              paddingBottom: '20px',
              paddingRight: '15px',
              border: '1px solid #D7DDE4',
              marginLeft: 76,
              width: '90%',
            }}
            >
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '15px',
                height: '30px',
                lineHeight: '30px',
              }}
              >
                <div style={{ display: 'flex' }}>
                  <Button
                    type="primary"
                    disabled={pageDisable}
                    style={{ borderRadius: '2px', width: '90px' }}
                    onClick={() => setGoodsDialog(true)}
                  >添加商品
                  </Button>
                  <div
                    style={{ marginLeft: '20px', marginRight: '20px', letterSpacing: '1px' }}
                  >已添加<span
                    style={{ color: 'red' }}
                  >{selectGoods.length}
                      </span>个商品
                  </div>
                </div>
                <Button
                  text
                  type="primary"
                  style={{ lineHeight: '30px', letterSpacing: '1px', color: '#111111' }}
                  disabled={pageDisable}
                  onClick={() => {
                    setSkuIds([]);
                    setSelectGoods([]);
                  }}
                >
                  <span style={{color: '#3399FF'}}>删除全部</span>
                  <span
                    className={`iconfont icon-icon-07 ${styles['del-icon']}`}
                    style={{ marginLeft: '5px',color: '#3399FF' }}
                  />
                </Button>
              </div>
              <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap' }}>
                {
                  selectGoods.length > 0 && selectGoods.map((item, index) => (
                    <div
                      key={index}
                      style={{ marginRight: '10px', width: '100px', position: 'relative' }}
                    >
                      <div style={{ marginBottom: '10px' }}>
                        <img
                          src={item.imagePath}
                          alt=""
                          style={{
                            width: '100px',
                            height: '100px',
                            border: '1px solid #D7DDE4',
                          }}
                        />
                      </div>
                      <div className={styles.name}>
                        {item.name}
                      </div>
                      <div className={styles.skuid}>
                        SKU:{item.skuId}
                      </div>
                      <div>
                        ￥{(+item.price).toFixed(2)}
                      </div>
                      <div
                        style={{
                          position: 'absolute',
                          top: 0,
                          right: 0,
                          fontSize: '16px',
                          width: '16px',
                          height: '16px',
                          background: '#9CA7B6',
                          cursor: 'pointer',
                          textAlign: 'center',
                          color: 'white',
                          lineHeight: '16px',
                        }}
                        onClick={() => {
                          const arr = selectGoods.filter((i) => i.skuId !== item.skuId);
                          setSelectGoods(arr);
                        }}
                      >×
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>
          }
          <SelectGoods
            goodsDialog={goodsDialog}
            closeDialog={() => setGoodsDialog(false)}
            skuIds={skuIds}
            confirmSkuid={(v) => setSkuIds(v)}
            selectGoods={selectGoods}
            confirmGoods={(v) => {
              setSelectGoods(v);
            }}
          />
          {/* 催付地区 */}
          <AreaChoose
            handlerClick={ChooseArea}
            chooseAreaType={chooseAreaType}
            //  传值对象
            area={area}
            type="催付"
            pageStatus={pageStatus}
            clearAll={() => {
              setArea({
                ...area,
                ids: [],
              });
            }}
          />
        </div>
      </div>
      <div className={styles.messageSetting}>
        {/* <div className={styles.title}>
          短信设置
        </div> */}
        <SectionTitle attr-intro="段落标题" title="短信设置" preface="2" />
        <div attr-intro="短信签名" style={{ display: 'flex', padding: '40px 0 60px' }}>
          <div attr-intro="短信签名-left" style={{ width: '70%' }}>
            <div attr-intro="短信签名" style={{ display: 'flex', marginBottom: '30px', alignItems: 'center' }}>
              <div style={{
                width: '20%',
                height: '30px',
                lineHeight: '30px',
                textAlign: 'right',
                paddingRight: '10px',
              }}
              >
                <span>短信签名：</span>
              </div>
              <div style={{ width: '80%', display: 'flex', alignItems: 'center' }}>
                <div className={styles.messageSign} style={{ width: '80%' }}>{messageSign}</div>
                {/* <Button style={{ paddingLeft: "10px" }} text type="primary" onClick={()=>{setUpdateSmsSignDialog(true)}} disabled={pageDisable}>修改短信签名</Button> */}
              </div>
            </div>
            <div style={{ display: 'flex', marginBottom: '15px' }}>
              <div style={{
                width: '20%',
                height: '30px',
                lineHeight: '30px',
                textAlign: 'right',
                paddingRight: '10px',
              }}
              >
                <span>短信内容：</span>
              </div>
              <div style={{ width: '80%' }}>
                {/* <Button type="primary"
                  onClick={() => { setOpenShortUrlDialog(true) }}
                  disabled={pageDisable}
                >短链接工具</Button> */}
                <Button
                  type="primary"
                  onClick={() => {
                    setSmsTemplateDialog(true);
                  }}
                  disabled={pageDisable}
                >选择短信模板
                </Button>
                <div style={{ display: 'flex', marginTop: '5px' }}>
                  <div style={{ marginTop: '10px', width: '80%' }}>
                    <Input.TextArea
                      placeholder="请输入"
                      value={messageForm.messageContent}
                      style={{ width: '100%', height: '120px', paddingTop: '5px' }}
                      rows={7}
                      // disabled={pageDisable}
                      disabled
                      onChange={(value) => {
                        let tempCount;
                        if ((messageSign.length + value.length + ADDLENGTH) <= 70) {
                          tempCount = Math.ceil((messageSign.length + value.length + ADDLENGTH) / 70);
                        } else {
                          tempCount = Math.ceil((messageSign.length + value.length + ADDLENGTH) / 67);
                        }
                        setMessageForm({
                          ...messageForm,
                          messageContent: value.trimStart(),
                          messageCount: tempCount || 1,
                        });
                      }}
                    />
                    <div style={{
                      backgroundColor: '#F5F7F9',
                      marginTop: '15px',
                      width: '100%',
                      height: '50px',
                      display: 'flex',
                      lineHeight: '50px',
                      whiteSpace: 'nowrap',
                      justifyContent: 'space-between',
                      paddingRight: '20px',
                    }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                          className={'iconfont icon-iconxx-32'}
                          style={{
                            fontSize: '26px',
                            paddingLeft: '20px',
                            paddingRight: '20px',
                            color: '#9CA7B6',
                          }}
                        />
                        {/* <div style={{marginRight:"20px"}}>预计发送:<span style={{paddingLeft:"5px",paddingRight:"5px",color: "#FF3333"}}>100</span>条</div> */}
                        <div>当前账户余额:<span style={{
                          paddingLeft: '5px',
                          paddingRight: '5px',
                          color: '#FF3333',
                        }}
                        >{accountRemain}
                        </span>条
                        </div>
                        {accountRemain === 0 &&
                        <span style={{ paddingLeft: '10px', color: '#FF3333' }}>余额不足</span>}
                      </div>
                      <div>
                        <Button
                          type="primary"
                          text
                          disabled={pageDisable}
                          onClick={() => {
                            history.push('/accountKeeper');
                          }}
                        >立即充值
                        </Button>&emsp;&emsp;
                        <Button
                          type="primary"
                          text
                          disabled={pageDisable}
                          onClick={() => {
                            getSmsNum();
                          }}
                        >刷新余额
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div style={{
                    marginTop: '10px',
                    lineHeight: '22px',
                    position: 'relative',
                    left: '10px',
                  }}
                  >
                    <div>
                      已输入：<span style={{
                      paddingRight: '2px',
                      color: '#FF3333',
                    }}>{messageSign && messageForm.messageContent ? messageSign.length + messageForm.messageContent.length + ADDLENGTH : messageSign.length+ADDLENGTH}
                      </span>/329
                      字(包含签名)
                    </div>
                    <div>当前计费：<span style={{
                      paddingRight: '5px',
                      color: '#FF3333',
                    }}
                    >{messageForm.messageCount}
                    </span>条
                    </div>
                    <div>
                      <Tooltip
                        trigger={
                          <span style={{
                            margin: '5px',
                            color: '#3399FF',
                            marginLeft: '0',
                            cursor: 'pointer',
                          }}
                          >计费内容及规则
                          </span>
                      }
                        align="r"
                        id="aria-tooltip"
                      >
                        <div style={{ width: '200px' }}>
                          说明<br />
                          1、70字计一条短信收费，超出70字按67字每条计,一个汉字，字母或者标点都算一个字。<br />
                          2、受短信运营商限制，签名和{CONSTANTS.LZ_SMS_CANCEL_WORD}，包含在字数中。<br />
                          {/* 3、请确保短链接【前后各加一个空格】,否则智能手机无法打开,使用短链接工具生成的短链已默认增加前后空格。<br /> */}
                          {/* 4、请确保每条短信中只有一条短连接，否则无法统计短信发送情况。<br /> */}
                          3、短信内容只能为普通字符，不能包含：【、】、）、表情符 等特殊字符。
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', marginBottom: '15px', marginTop: '30px' }}>
              <div style={{
                width: '20%',
                height: '30px',
                lineHeight: '30px',
                textAlign: 'right',
                paddingRight: '10px',
              }}
              >
                <span>测试短信接收人电话：</span>
              </div>
              <div style={{ width: '80%' }}>
                <Input
                  onChange={(value) => {
                    setReceivePhone(value.replace(/[^\d.]|^\./g, ''));
                  }}
                  disabled={pageDisable}
                  value={receivePhone}
                  style={{ width: 'calc(80% - 98px)', borderRadius: '2px' }}
                />
                <Button
                  type="secondary"
                  className={styles.btn}
                  style={{ marginLeft: '10px', width: '88px' }}
                  onClick={() => {
                    const reg = /^1\d{10}$/;
                    const flag = reg.test(receivePhone);
                    if (!messageForm.messageContent) {
                      LzMsg.error('短信内容不能为空！');
                    } else if (!receivePhone) {
                      LzMsg.error('测试手机号不能为空！');
                    } else if (!flag) {
                      LzMsg.error('请正确填写测试手机号！');
                    } else {
                      sendTestSms(selectedSms, receivePhone);
                    }
                  }}
                  disabled={pageDisable}
                >发送测试
                </Button>
                {/* <Button style={{paddingLeft:"10px"}} text type="primary" onClick={() => setPhoneModule(true)}>修改测试手机号</Button> */}
                <Button
                  type="primary"
                  text
                  style={{ marginLeft: '10px' }}
                  disabled={pageDisable}
                >测试记录
                </Button>
                <div style={{ color: '#9CA7B6', fontSize: '10px', paddingTop: '10px' }}>
                  <div style={{
                    letterSpacing: '.5px',
                    lineHeight: '20px',
                  }}
                  >注：请录入测试手机号后点击发送测试
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div attr-intro="短信签名-right" style={{ width: '30%' }}>
            <div className={styles.phoneBox}>
              <div className={styles.phoneImg}>

                <div
                  className={styles.previewMessage}
                  dangerouslySetInnerHTML={{ __html: `${phoneMsg}` }}
                />

              </div>
              <div
                style={{ marginLeft: '170px', width: '60px', marginTop: '15px', color: '#657180' }}
              >实时预览
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 生成短链接弹窗 */}
      <Dialog_GenerateShortURL
        visible={openShortUrlDialog}
        selected={(visible: boolean) => {
          setOpenShortUrlDialog(visible);
        }}
      />

      {/* 选择模板弹窗 */}
      {smsTemplateDialog &&
        <SmsTemplate
          scenes="202"
          closeDialog={() => {
            setSmsTemplateDialog(false);
          }}
          selectSms={(v) => {
            setMessageForm({
              ...messageForm,
              messageContent: v.templateContent.replace(` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`, ''),
              messageCount: v.smsNum || 1,
            });
            setSelectedSms(v);
          }}
        />
      }

      {/* 二次催付设置 */}
      <div className={styles.messageSetting}>
        <SectionTitle attr-intro="段落标题" title="二次催付设置" preface="3" />
        <div className={styles.switch}>
          {
            secondTaskActive
              ?
                <div>
                  <span
                    className={'iconfont icon-icon4-23'}
                    style={{
                      fontSize: '32px',
                      color: '#00BB66',
                      position: 'relative',
                      top: '4px',
                      paddingLeft: '0',
                    }}
                  />
                  <span style={{ color: '#00BB66' }}>二次催付已开启</span>
                </div>

              :
                <div>
                  <span
                    className={'iconfont icon-icon4-39'}
                    style={{
                      fontSize: '32px',
                      color: '#9CA7B6',
                      position: 'relative',
                      top: '4px',
                      paddingLeft: '0',
                    }}
                  />
                  <span style={{ color: '#9CA7B6' }}>二次催付</span>
                </div>
          }
          {
            pageStatus === 2 ?
              <div
                style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}
                className="switch-reset-color-orderPaymentMIssion"
              >
                <Switch
                  checked={secondTaskActive}
                  style={{ width: '55px' }}
                  disabled
                />
                {
                  secondTaskActive
                    ?
                      <div style={{
                        fontSize: '12px',
                        lineHeight: '32px',
                        height: '32px',
                        paddingLeft: '10px',
                      }}
                      >已开启
                      </div>
                    :
                      <div style={{
                        fontSize: '12px',
                        lineHeight: '32px',
                        height: '32px',
                        paddingLeft: '10px',
                      }}
                      >已关闭
                      </div>
                }

              </div>
              :
              <div
                style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}
                className="switch-reset-color-orderPaymentMIssion"
              >
                <Switch
                  checked={secondTaskActive}
                  onChange={() => {
                    // setSecondPayment(!secondPayment)
                    // let tempObj = { ...secondParams }
                    // tempObj.taskActive = !secondPayment
                    // setSecondParams(tempObj)
                    setSecondTaskActive(!secondTaskActive);
                  }}
                  style={{ width: '55px' }}
                />
                {
                  secondTaskActive
                    ?
                      <div style={{
                        fontSize: '12px',
                        lineHeight: '32px',
                        height: '32px',
                        paddingLeft: '10px',
                      }}
                      >已开启
                      </div>
                    :
                      <div style={{
                        fontSize: '12px',
                        lineHeight: '32px',
                        height: '32px',
                        paddingLeft: '10px',
                      }}
                      >已关闭
                      </div>
                }
              </div>
          }
        </div>
        {secondTaskActive &&
        <div style={{ display: 'flex', padding: '40px 0 60px' }}>
          <div style={{ width: '70%' }}>
            <div style={{ display: 'flex', marginBottom: '30px', alignItems: 'flex-start' }}>
              <div style={{
                width: '20%',
                height: '30px',
                textAlign: 'right',
                paddingRight: '10px',
                lineHeight: '44px',
              }}
              >
                <span>催付条件：</span>
              </div>
              <div style={{ width: '80%', display: 'flex', flexDirection: 'column' }}>
                <div style={{ marginTop: '10px', width: '80%' }}>
                  <span>当首次催付</span>&nbsp;&nbsp;
                  {/* <Select
                      followTrigger={true}
                      // defaultValue={0}
                      // defaultVisible = {true}  //下拉列表是否展开
                      dataSource={orderHourSelect}
                      value={delayTime.hours}
                      onChange={(value) => setDelayTime({ ...delayTime, hours: value })}
                      style={{ width: "30%" }}
                      disabled={pageDisable}
                      name="range" />
                    <span style={{ width: 44, textAlign: "center", display: "inline-block", paddingLeft: "auto" }}>小时</span> */}
                  <Select
                    aria-label="name is"
                    followTrigger
                    // defaultVisible = {true}  //下拉列表是否展开
                    dataSource={payMinuteSelect}
                    onChange={(value) => setDelayTime({ ...delayTime, minutes: value })}
                    disabled={pageDisable}
                    value={delayTime.minutes}
                    style={{ width: '30%' }}
                    name="range"
                  />
                  <span style={{ marginLeft: '10px' }}>分钟后仍未付尾款,向买家再次发送通知短信。</span>
                </div>
              </div>
            </div>
            <div attr-intro="短信签名" style={{ display: 'flex', marginBottom: '30px', alignItems: 'center' }}>
              <div style={{
                width: '20%',
                height: '30px',
                lineHeight: '30px',
                textAlign: 'right',
                paddingRight: '10px',
              }}
              >
                <span>短信签名：</span>
              </div>
              <div style={{ width: '80%', display: 'flex', alignItems: 'center' }}>
                <div className={styles.messageSign} style={{ width: '80%' }}>{messageSign}</div>
                {/* <Button style={{ paddingLeft: "10px" }} text type="primary" disabled={pageDisable}>修改短信签名</Button> */}
              </div>
            </div>
            <div style={{ display: 'flex', marginBottom: '15px' }}>
              <div style={{
                width: '20%',
                height: '30px',
                lineHeight: '30px',
                textAlign: 'right',
                paddingRight: '10px',
              }}
              >
                <span>短信内容：</span>
              </div>
              <div style={{ width: '80%' }}>
                {/* <Button type="primary"
                    onClick={() => { setOpenShortUrlDialog(true) }}
                    disabled={pageDisable}
                  >短链接工具</Button> */}
                <Button
                  type="primary"
                  onClick={() => {
                    setSecondSmsTemplateDialog(true);
                  }}
                  disabled={pageDisable}
                >选择短信模板
                </Button>
                <div style={{ display: 'flex', marginTop: '5px' }}>
                  <div style={{ marginTop: '10px', width: '80%' }}>
                    <Input.TextArea
                      placeholder="请输入"
                      value={messageFormSecond.messageContent}
                      style={{ width: '100%', height: '120px', paddingTop: '5px' }}
                      rows={7}
                      // disabled={pageDisable}
                      disabled
                      onChange={(value) => {
                        let tempCount;
                        if ((messageSign.length + value.length + ADDLENGTH) <= 70) {
                          tempCount = Math.ceil((messageSign.length + value.length + ADDLENGTH) / 70);
                        } else {
                          tempCount = Math.ceil((messageSign.length + value.length + ADDLENGTH) / 67);
                        }
                        setMessageFormSecond({
                          ...messageFormSecond,
                          messageContent: value.trimStart(),
                          messageCount: tempCount || 1,
                        });
                      }}
                    />
                    <div style={{
                      backgroundColor: '#F5F7F9',
                      marginTop: '15px',
                      width: '100%',
                      height: '50px',
                      display: 'flex',
                      lineHeight: '50px',
                      whiteSpace: 'nowrap',
                      justifyContent: 'space-between',
                      paddingRight: '20px',
                    }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                          className={'iconfont icon-iconxx-32'}
                          style={{
                            fontSize: '26px',
                            paddingLeft: '20px',
                            paddingRight: '20px',
                            color: '#9CA7B6',
                          }}
                        />
                        {/* <div style={{marginRight:"20px"}}>预计发送:<span style={{paddingLeft:"5px",paddingRight:"5px",color: "#FF3333"}}>100</span>条</div> */}
                        <div>当前账户余额:<span style={{
                          paddingLeft: '5px',
                          paddingRight: '5px',
                          color: '#FF3333',
                        }}
                        >{accountRemain}
                        </span>条
                        </div>
                        {accountRemain === 0 &&
                        <span style={{ paddingLeft: '10px', color: '#FF3333' }}>余额不足</span>}
                      </div>
                      <div>
                        <Button
                          type="primary"
                          text
                          disabled={pageDisable}
                          onClick={() => {
                            history.push('/accountKeeper');
                          }}
                        >立即充值
                        </Button>&emsp;&emsp;
                        <Button
                          type="primary"
                          text
                          disabled={pageDisable}
                          onClick={() => {
                            getSmsNum();
                          }}
                        >刷新余额
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div style={{
                    marginTop: '10px',
                    lineHeight: '22px',
                    position: 'relative',
                    left: '10px',
                  }}
                  >
                    <div>
                      已输入：<span style={{
                      paddingRight: '2px',
                      color: '#FF3333',
                    }}>{messageSign && messageFormSecond.messageContent ? messageSign.length + messageFormSecond.messageContent.length + ADDLENGTH : 0}
                      </span>/329
                      字(包含签名)
                    </div>
                    <div>当前计费：<span style={{
                      paddingRight: '5px',
                      color: '#FF3333',
                    }}
                    >{messageFormSecond.messageCount}
                    </span>条
                    </div>
                    <div>
                      <Tooltip
                        trigger={
                          <span style={{
                            margin: '5px',
                            color: '#3399FF',
                            marginLeft: '0',
                            cursor: 'pointer',
                          }}
                          >计费内容及规则
                          </span>
                      }
                        align="r"
                        id="aria-tooltip"
                      >
                        <div style={{ width: '200px' }}>
                          说明<br />
                          1、70字计一条短信收费，超出70字按67字每条计,一个汉字，字母或者标点都算一个字。<br />
                          2、受短信运营商限制，签名和{CONSTANTS.LZ_SMS_CANCEL_WORD}，包含在字数中。<br />
                          {/* 3、请确保短链接【前后各加一个空格】,否则智能手机无法打开,使用短链接工具生成的短链已默认增加前后空格。<br /> */}
                          {/* 4、请确保每条短信中只有一条短连接，否则无法统计短信发送情况。<br /> */}
                          3、短信内容只能为普通字符，不能包含：【、】、）、表情符 等特殊字符。
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* 二次催付选择模板弹窗 */}
            {secondSmsTemplateDialog && <SmsTemplate
              scenes="202"
              closeDialog={() => {
                setSecondSmsTemplateDialog(false);
              }}
              selectSms={(v) => {
                setMessageFormSecond({
                  ...messageFormSecond,
                  messageContent: v.templateContent.replace(` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`, ''),
                  messageCount: v.smsNum || 1,
                });
                setSelectedSmsSecond(v);
              }}
            />}
            <div style={{ display: 'flex', marginBottom: '15px', marginTop: '30px' }}>
              <div style={{
                width: '20%',
                height: '30px',
                lineHeight: '30px',
                textAlign: 'right',
                paddingRight: '10px',
              }}
              >
                <span>测试短信接收人电话：</span>
              </div>
              <div style={{ width: '80%' }}>
                <Input
                  onChange={(value) => {
                    setReceivePhoneSecond(value.replace(/[^\d.]|^\./g, ''));
                  }}
                  disabled={pageDisable}
                  value={receivePhoneSecond}
                  style={{ width: 'calc(80% - 98px)', borderRadius: '2px' }}
                />
                <Button
                  type="secondary"
                  className={styles.btn}
                  style={{ marginLeft: '10px', width: '88px' }}
                  onClick={() => {
                    const reg = /^1\d{10}$/;
                    const flag = reg.test(receivePhoneSecond);
                    if (!messageFormSecond.messageContent) {
                      LzMsg.error('二次催付短信内容不能为空！');
                    } else if (!receivePhoneSecond) {
                      LzMsg.error('二次催付测试手机号不能为空！');
                    } else if (!flag) {
                      LzMsg.error('请正确填写测试手机号！');
                    } else {
                      sendTestSms(selectedSmsSecond, receivePhoneSecond);
                    }
                  }}
                  disabled={pageDisable}
                >发送测试
                </Button>
                {/* <Button style={{paddingLeft:"10px"}} text type="primary" onClick={() => setPhoneModule(true)}>修改测试手机号</Button> */}
                <Button
                  type="primary"
                  text
                  style={{ marginLeft: '10px' }}
                  disabled={pageDisable}
                >测试记录
                </Button>
                <div style={{ color: '#9CA7B6', fontSize: '10px', paddingTop: '10px' }}>
                  <div style={{
                    letterSpacing: '.5px',
                    lineHeight: '20px',
                  }}
                  >注：请录入测试手机号后点击发送测试
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div attr-intro="短信签名-right" style={{ width: '30%' }}>
            <div className={styles.phoneBox}>
              <div className={styles.phoneImg}>

                <div
                  className={styles.previewMessage}
                  dangerouslySetInnerHTML={{ __html: `${phoneMsgSecond}` }}
                />

              </div>
              <div
                style={{ marginLeft: '170px', width: '60px', marginTop: '15px', color: '#657180' }}
              >实时预览
              </div>
            </div>
          </div>
        </div>}
      </div>
      {
        pageStatus !== 2 ? (
          <div className={styles.save}>
            <Button
              type="normal"
              className={styles.btn}
              onClick={() => {
                history.push('/ordersCare', { from: 'payment' });
              }}
            >
              取消
            </Button>
            <Button
              type="primary"
              className={styles.btn}
              style={{ marginLeft: '10px' }}
              onClick={() => {
                saveCallforpayment();
              }}
            >
              保存
            </Button>
          </div>
        ) : (
          <div className={styles.save}>
            <Button
              type="normal"
              className={styles.btn}
              onClick={() => {
                history.push('/ordersCare', { from: 'payment' });
              }}
            >
              返回
            </Button>
          </div>
        )
      }
    </div>
  );
};

export default OrderPaymentCreate;
